import PropTypes from 'prop-types'
import React from 'react'
import CheckboxesField from '../question_config_fields/CheckboxesField'
import CheckBoxIcon from '@material-ui/icons/CheckBox'
import CheckboxesCitizenField from '../question_fields/CheckboxesCitizenField'

const Form = props => {
  return <CheckboxesField baseName={props.baseName} />
}

const Template = props => {
  if (props.question.editable_alternative) {
    return <CheckboxesField baseName={props.baseName} label={props.question.payload?.label} />
  } else {
    return <CheckboxesCitizenField payload={props.question.payload} name={props.name} disabled />
  }
}

const CheckboxesQuestion = {
  selectOption: {
    value: 'checkboxes',
    label: 'Casillas (selección múltiple)',
    icon: <CheckBoxIcon fontSize="small" />
  },
  Form,
  Template,
  name: 'CheckboxesQuestion'
}

export default CheckboxesQuestion

Form.propTypes = {
  baseName: PropTypes.string
}

Template.propTypes = {
  baseName: PropTypes.string,
  name: PropTypes.string,
  question: PropTypes.object.isRequired
}
